import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixMultilingualMachineV1TranslationCreditsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'editor._base_domain_': [
      {
        srcPath: '/_api/translation-credits/v1',
        destPath: '/v1',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/translation-credits/v1',
        destPath: '/v1',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/translation-credits/v1',
        destPath: '/v1',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/translation-credits/v1',
        destPath: '/v1',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/translation-credits/v1',
        destPath: '/v1',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/translation-credits/v1',
        destPath: '/v1',
      },
    ],
    _: [
      {
        srcPath: '/_api/translation-credits',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_multilingual_translation-credits';

/**
 * Retrieves a site's word credit data.
 *
 * For sites with a limited quota, you can calculate the available word credits by subtracting the credits used from the quota.
 * For example, if a site has a quota of 100 credits and all credits have been used (`"creditsUsed": 100`), the available word credits will be 0.
 * If a Wix user purchases an additional 50 credits, the `quota` will increase to `150`, and the site will have 50 available word credits.
 */
export function getCreditData(payload: object): RequestOptionsFactory<any> {
  function __getCreditData({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.multilingual.machine.v1.credit_data',
      method: 'GET' as any,
      methodFqn: 'wix.multilingual.machine.v1.TranslationCredits.GetCreditData',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMultilingualMachineV1TranslationCreditsUrl({
        protoPath: '/v1/credit',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getCreditData;
}

/** Checks whether a site has enough credits to translate the specified number of words. */
export function checkSufficientCredits(
  payload: object
): RequestOptionsFactory<any> {
  function __checkSufficientCredits({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.multilingual.machine.v1.credit_data',
      method: 'POST' as any,
      methodFqn:
        'wix.multilingual.machine.v1.TranslationCredits.CheckSufficientCredits',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMultilingualMachineV1TranslationCreditsUrl({
        protoPath: '/v1/credit/is-eligible',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __checkSufficientCredits;
}
